export const pushToGtm = params => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    ...params,
  })
}
